import { UserDefinedOrganizationType } from 'globalTypes';

export const REQUESTER_ROLE_OPTIONS = [
  {
    label: 'Superintendent / Asst. Superintendent',
    value: 'superintendent_or_asst',
  },
  {
    label: 'Principal / Asst. Principal',
    value: 'principal_or_asst',
  },
  {
    label: 'Instructional / Academic Technology',
    value: 'instructional_academic_tech',
  },
  {
    label: 'Information Technology',
    value: 'information_tech',
  },
  {
    label: 'Communication',
    value: 'communication',
  },
  {
    label: 'Curriculum',
    value: 'curriculum',
  },
  {
    label: 'Professional Development',
    value: 'professional_development',
  },
  {
    label: 'Teacher/Faculty',
    value: 'teacher_faculty',
  },
  {
    label: 'Parent',
    value: 'parent',
  },
  {
    label: 'Student',
    value: 'student',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const ORG_TYPE_OPTIONS = [
  {
    label: 'School',
    value: UserDefinedOrganizationType.School,
  },
  {
    label: 'District',
    value: UserDefinedOrganizationType.District,
  },
  {
    label: 'Higher education',
    value: UserDefinedOrganizationType.HigherEducation,
  },
  {
    label: 'Other',
    value: UserDefinedOrganizationType.Other,
  },
];
